import React, { PureComponent } from 'react';

import { shouldRenderMobile } from '@philips-emr/hpms-provider-commons';
import { Text } from '@philips-emr/tws-components';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import {
  eventListener,
  number,
  string,
} from '@philips-emr/tws-core/lib/component/prop-types';

import './hpms-provider-options.scss';
import { HpmsProviderOptionsApi } from '../../api';

@AwesomeComponent({
  type: ComponentType.DATA_DISPLAY,
  api: HpmsProviderOptionsApi,
})
class HpmsProviderOptions extends PureComponent {
  static propTypes = {
    nrSeqProvider: number,
    title: string,
    subtitle: string,
    onOptionClick: eventListener,
  };

  onOption() {
    const { onOptionClick, subtitle, nrSeqProvider } = this.props;
    let { title } = this.props;
    if (shouldRenderMobile && title.length > 34) {
      title = title.slice(0, 34).concat('...');
    }

    const value = { title, subtitle, nrSeqProvider };

    onOptionClick && onOptionClick({ value });
  }

  render() {
    const { title, subtitle } = this.props;
    return (
      <div className="c-hpms-contratos-options" onClick={() => this.onOption()}>
        <Text
          value={title}
          bold
          formatters={
            shouldRenderMobile()
              ? { value: { name: 'overflow', options: { limit: 40 } } }
              : ''
          }
        />
        <Text value={subtitle} />
      </div>
    );
  }
}

export default HpmsProviderOptions;
